import { useEffect, useState } from "react";
import { BaseTag, AddTagToNodeRequest } from "../types";
import { Tag } from "./Tag";
import { AddTag } from "./AddTag";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Stack,
} from "@altimateai/lego";
import { ArrowDown } from "@assets/icons";

interface TagsListProps {
  tags: BaseTag[];
  entity: AddTagToNodeRequest["entity"];
}

export const TagsList = ({ tags = [], entity }: TagsListProps) => {
  const [currentTags, setCurrentTags] = useState<BaseTag[]>(tags);
  const displayTags = currentTags.slice(0, 3);
  const remainingTags = currentTags.slice(3);
  const remainingCount = remainingTags.length;

  useEffect(() => {
    // To avoid re-rendering the component when the tags are updated
    if (tags.length > 0) {
      setCurrentTags(tags);
    }
  }, [tags]);

  const onTagRemove = (tag: BaseTag) => {
    setCurrentTags(prev => prev.filter(t => t.rk !== tag.rk));
  };

  const onAddTag = (tag: BaseTag) => {
    setCurrentTags(prev => [tag, ...prev]);
  };

  return (
    <Stack direction="row" align="center" gap="sm" className="al-flex-wrap">
      <span className="al-text-sm al-text-gray-500">Tags:</span>
      {displayTags.map(tag => (
        <Tag key={tag.rk} tag={tag} entity={entity} onRemove={() => onTagRemove(tag)} />
      ))}
      {remainingCount > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="al-text-brand al-font-normal !al-bg-bg-brand !al-py-1 al-h-auto al-border-none !al-rounded-full hover:al-text-brand"
            >
              {remainingCount} more
              <ArrowDown className="al-w-4 al-h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="al-min-w-0">
            {remainingTags.map(tag => (
              <div key={tag.rk} className="al-px-2 al-py-1">
                <Tag tag={tag} entity={entity} onRemove={() => onTagRemove(tag)} />
              </div>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      <AddTag
        entity={entity}
        existingTagIds={currentTags.map(tag => tag.rk).filter((rk): rk is string => Boolean(rk))}
        onAddTag={onAddTag}
      />
    </Stack>
  );
};
